const attributes = {
  name: 'Nom',
  email: 'Email',
  password: 'Mot de passe',
  password_confirmation: 'Confirmer le mot de passe',
}

export default attributes
